import api from './apiSetup';
import { serialize } from './util';

export const fetchCompoundBundles = params => {
  params = {
    ...params
  };
  const query = serialize(params);
  return api(`/bundles/compound/${query ? `?${query}` : ''}`);
};

export default {
  fetchCompoundBundles
};
